import { percentage } from '../utils/numberUtils'

export default {
  methods: {
    percentageFormat: (value) => {
      return percentage(value) + '%'
    }
  }
}
